/**
 * Wrapper classes and custom properties for Circular Badge.
 *
 * Shared by edit.jsx and save.jsx for the same reason ring.jsx is: the saved
 * markup and the editor preview have to match exactly or the block fails
 * validation the next time it is opened.
 */

import { resolvePresetValue } from '../../utils/helpers';

/**
 * @param {Object} attributes Block attributes.
 * @return {string} Wrapper class list.
 */
export function getWrapperClasses({ spin, spinDirection, centreBackground }) {
  return [
    'brandy-circular-badge',
    centreBackground ? 'has-centre-background' : '',
    spin ? 'is-spinning' : '',
    spin && spinDirection === 'counter-clockwise' ? 'is-reversed' : '',
  ]
    .filter(Boolean)
    .join(' ');
}

/**
 * Custom properties rather than inline declarations: the diameter drives the
 * box, the ring and the centre disc from one number, and the disc's colour has
 * to land on a pseudo-element, which inline styles cannot reach.
 *
 * @param {Object} attributes Block attributes.
 * @return {Object} React style object.
 */
export function getWrapperStyles({
  size,
  textInset,
  spinDuration,
  centreBackground,
}) {
  const styles = {
    '--brandy-circular-badge-size': `${size}px`,
    '--brandy-circular-badge-inset': `${textInset}px`,
    '--brandy-circular-badge-duration': `${spinDuration}s`,
  };

  if (centreBackground) {
    styles['--brandy-circular-badge-centre-background'] =
      resolvePresetValue(centreBackground);
  }

  return styles;
}
